import React from "react";
import _ from "lodash";
import XDate from "xdate";
import Tabs from "Components/tabs/Tabs";
import Security from "./settings/Security";
import Autoresponder from "./settings/Autoresponder";
import Details from "./settings/Details";
import Generals from "./settings/Generals";
import Webmail from "./settings/Webmail";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import { alertSuccess, alertError } from "Utils/alerts";
import PropTypes from "prop-types";
import { formatServerErrors } from "Utils/serverFormats";
import t from "Utils/translation";

const formInitialState = {
  forwards: [],
  allow_nets: [],
};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isLoggedUserTrial: PropTypes.func,
};

class EmailAccountSettingsPage extends React.Component {
  constructor(props, context) {
    super(props);
    const loggedUser = context.getLoggedUser();
    let domainCode, emailCode, postmasterCode;
    if (context.getLoggedUserType() === "EmailAccount") {
      domainCode = loggedUser.domain_code;
      emailCode = loggedUser.code;
    } else if (props.isLinkedEmailAccount) {
      domainCode = props.emailAccount.domain_code;
      emailCode = props.emailAccount.code;
    } else if (context.getLoggedUserType() === "Postmaster") {
      domainCode = loggedUser.domain_code;
      emailCode = props.match.params.emailCode;
    } else {
      domainCode = props.match.params.domainCode;
      emailCode = props.match.params.emailCode;
      postmasterCode = props.match.params.postmasterCode;
    }

    this.state = {
      domainCode,
      emailCode,
      postmasterCode,
      loggedUser,
      signatures: [],
    };
  }

  loadEmailAccountSettings() {
    const { emailAccount, domain } = this.props;

    let fullStartDate = XDate(emailAccount.autoresponder_start_date);
    let fullEndDate = XDate(emailAccount.autoresponder_end_date);

    // set default hour
    if (!emailAccount.autoresponder_start_date) {
      let startH = fullStartDate.getHours() + 1;
      if (startH > 23) {
        startH = 1;
        fullStartDate.addDays(1);
      }

      let endH = fullStartDate.getHours() + 2;
      if (endH > 23) {
        endH = 2;
        fullEndDate.addDays(1);
      }

      fullStartDate.setHours(startH).setMinutes(0);
      fullEndDate.setHours(endH).setMinutes(0);
    }

    let hourStartDate = `${fullStartDate.toString("HH")}:${fullStartDate.toString("mm")}`;
    let hourEndDate = `${fullEndDate.toString("HH")}:${fullEndDate.toString("mm")}`;

    if (hourEndDate)
      this.props.setInitialValues({
        ...emailAccount,
        imap_disabled: domain.imap_disabled ? true : emailAccount.imap_disabled,
        pop_disabled: domain.pop_disabled ? true : emailAccount.pop_disabled,
        smtp_disabled: domain.smtp_disabled ? true : emailAccount.smtp_disabled,
        webmail_disabled: domain.webmail_disabled ? true : emailAccount.webmail_disabled,
        dav: emailAccount.dav,
        activesync: emailAccount.activesync,
        calendar: emailAccount.calendar,
        meeting: emailAccount.meeting,
        chat: emailAccount.chat,
        password: "",
        password_confirmation: "",
        autoresponder_start_date: fullStartDate,
        autoresponder_start_hour: hourStartDate,
        autoresponder_end_date: fullEndDate,
        autoresponder_end_hour: hourEndDate,
        hide_from_addressbook_company: emailAccount.hide_from_addressbook_company,
        allow_nets:
          emailAccount.allow_nets && emailAccount.allow_nets[0] === "0.0.0.0/0" ? [] : emailAccount.allow_nets,
      });
  }

  componentDidMount() {
    const { domainCode, emailCode, postmasterCode } = this.state;
    this.props.getEmailOutboundLimits(domainCode, emailCode || postmasterCode);

    this.getEmailAccountSignatures();
    this.loadEmailAccountSettings();
  }

  getEmailAccountSignatures = () => {
    const { emailCode, postmasterCode } = this.state;
    const api = new QboxmailApi({ useCookie: true });
    api
      .getEmailSignatures(emailCode || postmasterCode)
      .then((res) => {
        this.setState({ signatures: res.resources });
      })
      .catch((response) => {});
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.emailAccount &&
      nextProps.emailAccount &&
      nextProps.emailAccount.code !== this.props.emailAccount.code
    ) {
      const domainCode = nextProps.emailAccount.domain_code;
      const emailCode = nextProps.emailAccount.code;
      this.setState({
        domainCode: domainCode,
        emailCode: emailCode,
      });

      this.props.getEmailOutboundLimits(domainCode, emailCode);
      this.loadEmailAccountSettings();
    }
  }

  validate({ password, password_confirmation }) {
    let errors = {};
    if (password && password !== "" && password.length < 8) errors.password = t("errorMsg.length.passowrd");
    if (password && password !== password_confirmation) {
      errors.password_confirmation = t("errorMsg.notMarch.passowrd");
    }
    return errors;
  }

  submitForm = (e, fieldsToSend = []) => {
    let { refreshEmailAccount, setFormLoading, unsetFormLoading, setFormErrors, formData } = this.props;

    const { domainCode, emailCode, postmasterCode } = this.state;
    e.preventDefault();
    setFormLoading();
    const values = _.clone(formData);
    const errors = this.validate(formData);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      const dataToSend = {};
      fieldsToSend.forEach((f) => (dataToSend[f] = values[f]));

      if (!dataToSend.password && !dataToSend.password_confirmation) {
        delete dataToSend.password;
        delete dataToSend.password_confirmation;
      }

      if (dataToSend.autoresponder_start_hour) {
        let timeSplitted = dataToSend.autoresponder_start_hour.split(":");
        dataToSend.autoresponder_start_date = new XDate(dataToSend.autoresponder_start_date)
          .setHours(timeSplitted[0])
          .setMinutes(timeSplitted[1]);
        delete dataToSend.autoresponder_start_hour;
      }

      if (dataToSend.autoresponder_end_hour) {
        let timeSplitted = dataToSend.autoresponder_end_hour.split(":");
        dataToSend.autoresponder_end_date = new XDate(dataToSend.autoresponder_end_date)
          .setHours(timeSplitted[0])
          .setMinutes(timeSplitted[1]);
        delete dataToSend.autoresponder_end_hour;
      }

      const code = emailCode || postmasterCode;
      const api = new QboxmailApi({ useCookie: true });
      api
        .editEmailAccount(domainCode, code, dataToSend)
        .then(() => {
          unsetFormLoading();
          this.props.setFormErrors({});
          refreshEmailAccount(domainCode, code);
          alertSuccess(t("alert.emailUpdatedSuccess"));
        })
        .catch((response) => {
          formatServerErrors(response).then((errors) => {
            this.props.setFormErrors(errors);
            this.props.unsetFormLoading();
            alertError(t("alert.validationFailed"));
          });
        });
    }
  };

  render() {
    const { signatures } = this.state;

    const user = this.context.getLoggedUser();

    let canEdit = true;
    if (user.type === "TeamMember" && !user.permissions.includes("edit_email_accounts")) {
      canEdit = false;
    }

    let extraTabs = {};
    if (user.type !== "EmailAccount") {
      extraTabs[t("tab.security")] = (
        <Security
          {...this.props}
          submitForm={this.submitForm}
          loggedUser={this.state.loggedUser}
          isLoggedUserTrial={this.context.isLoggedUserTrial()}
        />
      );
    }

    return (
      <Tabs
        {...this.props}
        tabs={{
          [t("tab.registry")]: <Details {...this.props} submitForm={this.submitForm} canEdit={canEdit} />,
          [t("tab.general")]: (
            <Generals
              {...this.props}
              submitForm={this.submitForm}
              isLoggedUserTrial={this.context.isLoggedUserTrial()}
              isLoggedUserAdmin={this.context.isLoggedUserAdmin()}
              canEdit={canEdit}
              loggedUser={this.state.loggedUser}
            />
          ),
          ...extraTabs,
          [t("tab.autoresponder")]: (
            <Autoresponder
              {...this.props}
              submitForm={this.submitForm}
              isLoggedUserTrial={this.context.isLoggedUserTrial()}
              canEdit={canEdit}
            />
          ),

          [t("tab.webmail")]: (
            <Webmail
              signatures={signatures}
              onSignatureChanged={this.getEmailAccountSignatures}
              submitForm={this.submitForm}
              {...this.props}
            />
          ),
          // [t("tab.webmail")]: <Webmail submitForm={this.submitForm} {...this.props} />
        }}
      />
    );
  }
}

EmailAccountSettingsPage.contextTypes = ContextTypes;

export default withFormState(EmailAccountSettingsPage, formInitialState);
